import React, { useCallback } from 'react';
import t from 'rcm-i18n';
import './PwsCouponOwnerControlsComponent.scss'
import { CouponFromConfigConfig } from './types';
import { Modal } from 'forms/src';
import { PWS_COUPONS_VALIDATION_RULES } from '@reliv/pws-core/src';

interface Props {
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
    coupon: CouponFromConfigConfig;
    value: string;
    onValueChange: (newValue) => void;
}

export function CouponRowCustomizeModal({ coupon, open, onOk, onCancel, value, onValueChange }: Props) {
    const handleCustomizeDialogOk = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        onOk();
    }, [onOk]);

    const getCouponCodeRulesText = () => {
        const couponCodeRulesTextParts = t(
            'These coupon codes must begin with "{prefix}" and cannot be longer than {maxLength} characters. You may only use terms that follow Reliv’s {complianceGuidelines}. If you customize this coupon code, the previous code will no longer work.',
            {
                prefix: PWS_COUPONS_VALIDATION_RULES.customCouponCodeValue.mustStartWith,
                maxLength: PWS_COUPONS_VALIDATION_RULES.customCouponCodeValue.maxLength,
            }
        ).split('{complianceGuidelines}');
        return <span>{couponCodeRulesTextParts[0]}<a href="https://reliv-static.s3-us-west-2.amazonaws.com/art/WebStuff/2018RelivSite/MyResources/OnlineCertification/Compliance/FlaggablePhrases/ComplianceFlaggablePhrases-web.pdf" target="_blank">{t('compliance guidelines')}</a>{couponCodeRulesTextParts[1]}</span>
    }

    return <Modal show={open}
        className="edit-coupon-code-popup"
        onFadeOut={onCancel}
    >
        <form onSubmit={handleCustomizeDialogOk}>

            <div>
                <div className="form-group">
                    <label htmlFor={'new-coupon-code-' + coupon.id}>
                        {t('Customize the Coupon Code for the {discountPercent}% Discount', coupon)}
                    </label>
                    <input
                        className="form-control" id={'new-coupon-code-' + coupon.id}
                        type="text"
                        value={value}
                        onChange={onValueChange}
                    />
                    <br /><br />
                    <p>{getCouponCodeRulesText()}</p>
                </div>
                <br />
                <div className="clearfix button-container">
                    <button className="pull-left btn btn-default"
                        onClick={onCancel}>
                        {t('Cancel')}
                    </button>
                    <button type="submit" className="pull-right btn btn-primary">
                        {t('Ok')}
                    </button>
                </div>
            </div>
        </form>
    </Modal>
}